/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-underscore-dangle */

'use-strict';

import { IScope } from 'angular';

import { FileInput } from '../../../src/app/@types';
import { EFileSection } from '../../../src/app/@shared-types/misc/file';

import { SalesAPIService } from '../../../shared/api/sales-api.service';
import { NumberConversionService } from '../../../shared/converter/number-converter.service';
import { FileService, FileServiceUploadRequest } from '../../../shared/storage/file.service';
import { AutoboardVehicle } from '../../../src/app/@shared-types/vehicle';
import { ConfigService } from '../../../shared/config/config.service';
import { EInventoryState } from '../../../src/app/@shared-types/vehicle/enums';
import { DeepPartial } from '../../../src/app/@shared-types';
import { VehicleFormComponentExitFunction } from '../../../src/app/@types/vehicle';

interface DeliveryScope extends IScope {
  sending: boolean,
  exitForm: () => void,
  exit: (data: VehicleFormComponentExitFunction) => void,
  formTransmission: () => void,
  vehicle: AutoboardVehicle,
  newVehicleData: {
    deliveryFile?: FileInput,
    tireLabel?: FileInput,
    co2Label?: FileInput,
    deliveryDamage?: FileInput,
    deliveryDate: string,
    location: string,
  },
  locations: { [key: string]: string } | null,
}

/* @ngInject */
export default function DeliveryFormController(
  $rootScope: IScope,
  $scope: DeliveryScope,
  fileService: FileService,
  salesApiService: SalesAPIService,
  numberConversionService: NumberConversionService,
  configService: ConfigService,
): void {
  $scope.sending = false;
  $scope.locations = configService.get('general_locations');

  $scope.newVehicleData = {
    co2Label: undefined,
    deliveryDamage: undefined,
    deliveryDate: '',
    location: $scope.vehicle.vehicleData.inventory?.location || '',
    deliveryFile: undefined,
    tireLabel: undefined,
  };

  $scope.exitForm = () => $scope.exit({ removeLock: true });

  $scope.formTransmission = async () => {
    $scope.sending = true;

    const deliveryFile = $scope.newVehicleData.deliveryFile || null;
    if (deliveryFile?.file) {
      const deliveryFileRequest: FileServiceUploadRequest = {
        identifier: String($scope.vehicle._id),
        section: EFileSection.VEHICLE,
        type: deliveryFile.fileType,
      };

      await fileService
        .uploadContextualFile(deliveryFile.file, deliveryFile.progressBar, deliveryFileRequest);
    }

    const tireLabelFile = $scope.newVehicleData.tireLabel || null;
    if (tireLabelFile?.file) {
      const tireLabelFileRequest: FileServiceUploadRequest = {
        identifier: String($scope.vehicle._id),
        section: EFileSection.VEHICLE,
        type: tireLabelFile.fileType,
      };

      await fileService
        .uploadContextualFile(tireLabelFile.file, tireLabelFile.progressBar, tireLabelFileRequest);
    }

    const co2LabelFile = $scope.newVehicleData.co2Label || null;
    if (co2LabelFile?.file) {
      const co2LabelFileRequest: FileServiceUploadRequest = {
        identifier: String($scope.vehicle._id),
        section: EFileSection.VEHICLE,
        type: co2LabelFile.fileType,
      };

      await fileService
        .uploadContextualFile(co2LabelFile.file, co2LabelFile.progressBar, co2LabelFileRequest);
    }

    const damageFile = $scope.newVehicleData.deliveryDamage || null;
    if (damageFile?.file) {
      const damageFileRequest: FileServiceUploadRequest = {
        identifier: String($scope.vehicle._id),
        section: EFileSection.VEHICLE,
        type: damageFile.fileType,
      };

      await fileService
        .uploadContextualFile(damageFile.file, damageFile.progressBar, damageFileRequest);
    }

    const changedVals: DeepPartial<AutoboardVehicle> = {
      _id: $scope.vehicle._id,
      vehicleData: {
        inventory: {
          location: $scope.newVehicleData.location,
          locationDescription: $scope.locations![$scope.newVehicleData.location!],
          state: EInventoryState.Stock,
          // eslint-disable-next-line max-len
          deliveryDate: numberConversionService.frontendStringToDate($scope.newVehicleData.deliveryDate),
        },
      },
    };

    await salesApiService.putVehicle(changedVals);
    return $scope.exit({});
  };
}
